// @ts-nocheck

import type { LocalizedMessages } from './types.js';

/** Strings used by Cimpress UI components, localized in the `en-US` locale. */
export const enUS: LocalizedMessages = {
  common: { clearValue: `Clear`, dismiss: `Dismiss`, clearValueDescription: `Press Escape to clear text.` },
  copyToClipboard: { success: `Copied to clipboard.`, failure: `Failed to copy to clipboard.` },
  label: { required: `(required)` },
  datePicker: {
    clearValue: `Clear`,
    openCalendar: `Open calendar`,
    previousMonth: `Previous month`,
    nextMonth: `Next month`,
    switchToYearView: `Year view`,
    previousYear: `Previous year`,
    nextYear: `Next year`,
    switchToMultiYearView: `Multi-year view`,
    previousMultiYearSection: (args, formatter) => `Previous ${formatter.number(args.yearCount)} years`,
    nextMultiYearSection: (args, formatter) => `Next ${formatter.number(args.yearCount)} years`,
  },
  numberField: { decrement: `Decrement`, increment: `Increment` },
  pagination: {
    goToPage: (args, formatter) => `Page ${formatter.number(args.pageNumber)}`,
    previousPage: `Previous page`,
    nextPage: `Next page`,
    selectedPageAnnouncement: (args, formatter) => `Selected page: ${formatter.number(args.pageNumber)}`,
  },
  slider: { rangeStart: `Range start`, rangeEnd: `Range end` },
  tagField: {
    itemsSelected: (args, formatter) =>
      `${formatter.plural(args.selectedItemCount, { one: () => `${formatter.number(args.selectedItemCount)} item selected`, other: () => `${formatter.number(args.selectedItemCount)} items selected` })}`,
  },
  filePicker: {
    chooseFile: `Choose file`,
    noFilesSelected: (args, formatter) =>
      `${formatter.select({ true: `No files selected`, other: `No file selected` }, args.allowsMultiple)}`,
    multipleFilesSelected: (args, formatter) => `${formatter.number(args.fileCount)} files`,
  },
  table: { loadingData: `Loading data`, toggleColumnSortOrder: `Toggle sort order of column:` },
  simpleAuthTool: {
    logIn: `Log in`,
    logOut: `Log out`,
    profileDetails: (args) => `Profile details for ${args.userFullName}`,
    unknownUser: `Unknown User`,
  },
  UNSTABLE_collection: {
    loading: `Loading items`,
    loadingMore: `Loading more items`,
    itemsSelected: (args, formatter) =>
      `${formatter.plural(args.selectedItemCount, { one: () => `${formatter.number(args.selectedItemCount)} item selected`, other: () => `${formatter.number(args.selectedItemCount)} items selected` })}`,
  },
};
